import { createAction, props } from '@ngrx/store';

export const loadApproveBusinessFicaDocuments = createAction(
  '[ApproveBusinessFicaDocuments] Load ApproveBusinessFicaDocuments',
  props<{ businessId: string; uploadedFileId: string }>()
);

export const loadApproveBusinessFicaDocumentsSuccess = createAction(
  '[ApproveBusinessFicaDocuments] Load ApproveBusinessFicaDocuments Success',
  props<{ response: string }>()
);

export const loadApproveBusinessFicaDocumentsFailure = createAction(
  '[ApproveBusinessFicaDocuments] Load ApproveBusinessFicaDocuments Failure',
  props<{ error: Error | any }>()
);
